import * as React from 'react'

export default class extends React.Component<any, any>{

    render(){
        return (
            <div className="col-12">
                <hr { ...this.props }/>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/divider.tsx